import { Fragment, memo, ReactElement } from 'react';
import AccordionFilterNotifications from './filter-notifications';
import AccordionFilterNotificationsPerson from './filter-notifications-person';
import { ResearchNotifications } from 'civil-status/view-models/notifications-list';

interface FilterNotificationsProps {
  openPerson?: boolean;
  setOpenPerson: (value: boolean) => void;
  openNotifications?: boolean;
  setOpenNotifications: (value: boolean) => void;
  handleSubmitResearchNotifications: (values: ResearchNotifications) => void;
  handleSubmitResearchPerson: (values: ResearchNotifications) => void;
  idCat?: string;
  initialValues?: ResearchNotifications;
}

const FilterNotificationsComponent = ({
  openNotifications,
  setOpenNotifications,
  openPerson,
  setOpenPerson,
  handleSubmitResearchNotifications,
  handleSubmitResearchPerson,
  idCat,
  initialValues,
}: FilterNotificationsProps): ReactElement => {
  return (
    <Fragment>
      <AccordionFilterNotifications
        open={openNotifications}
        setOpen={setOpenNotifications}
        handleSubmitResearchNotifications={handleSubmitResearchNotifications}
        idCat={idCat}
        initialValues={initialValues}
      />
      <AccordionFilterNotificationsPerson
        open={openPerson}
        setOpen={setOpenPerson}
        handleSubmitResearchPerson={handleSubmitResearchPerson}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

FilterNotificationsComponent.displayName = 'Research notifications - Filters component';

const FilterNotifications = memo(FilterNotificationsComponent);

export default FilterNotifications;
